import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API, imgUrl } from "../lib/storeApi";
import SEO from "../components/SEO";
import { Calendar, ArrowRight, Newspaper } from "lucide-react";

const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" }) : "");

const Blog = () => {
  const [posts, setPosts] = useState(null);
  useEffect(() => {
    fetch(`${API}/blog/posts`).then((r) => r.json()).then((d) => setPosts(Array.isArray(d) ? d : [])).catch(() => setPosts([]));
  }, []);

  const listSchema = posts && posts.length ? {
    "@context": "https://schema.org", "@type": "Blog", name: "Set Up Home Theater Blog",
    blogPost: posts.slice(0, 20).map((p) => ({
      "@type": "BlogPosting", headline: p.title, url: `https://www.setuphometheater.com/blog/${p.slug}`,
      datePublished: p.published_at || p.created_at, image: p.cover_image || undefined,
    })),
  } : null;

  return (
    <main data-testid="blog-list">
      <SEO title="Blog — AV Tips, Guides & Installs" description="Home theater tips, install guides and AV know-how from Set Up Home Theater — serving Rocky Mount and Eastern North Carolina." path="/blog" jsonLd={listSchema} />
      <section className="bg-[#0a1f44] text-white">
        <div className="max-w-[1100px] mx-auto px-5 lg:px-8 py-16">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-[#3b9dff] bg-[#3b9dff]/15 px-3 py-1.5 rounded-full"><Newspaper className="w-3.5 h-3.5" /> The Blog</span>
          <h1 className="text-4xl sm:text-5xl font-extrabold mt-4">AV tips, guides & install stories</h1>
          <p className="text-slate-300 mt-3 max-w-2xl">Practical advice from our install team — TVs, home theater, wiring, smart home and more.</p>
        </div>
      </section>

      <section className="max-w-[1100px] mx-auto px-5 lg:px-8 py-14">
        {posts === null ? (
          <p className="text-slate-400">Loading…</p>
        ) : posts.length === 0 ? (
          <div className="text-center py-16"><Newspaper className="w-12 h-12 text-slate-300 mx-auto" /><p className="text-slate-500 mt-3">No posts yet — check back soon.</p></div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((p) => (
              <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group bg-white rounded-2xl border border-slate-200 overflow-hidden hover:shadow-lg hover:-translate-y-0.5 transition-all flex flex-col">
                <div className="h-44 bg-[#0a1f44] overflow-hidden">
                  {p.cover_image ? <img src={imgUrl(p.cover_image)} alt={p.title} className="w-full h-full object-cover" loading="lazy" /> : <div className="w-full h-full flex items-center justify-center"><Newspaper className="w-8 h-8 text-white/30" /></div>}
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <p className="text-xs text-slate-400 flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" /> {fmtDate(p.published_at || p.created_at)}</p>
                  <h2 className="text-lg font-bold text-[#0a1f44] mt-2 line-clamp-2">{p.title}</h2>
                  <p className="text-sm text-slate-500 mt-2 line-clamp-3 flex-1">{p.excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-[#3b9dff] text-sm font-semibold">Read more <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" /></span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </main>
  );
};

export default Blog;
